import { gql } from '../../../../../hooks'

export const DELETE_MODELS = gql`
  mutation AdministrationDeleteLubricantModels($id: ID!) {
    aDelete(path: "lubricant/models", id: $id) {
    }
  }
`

export const LIST_MODELS = gql`
  query AdministrationListLubricantModels(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "lubricant/models"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
